import { render, staticRenderFns } from "./SampleResultAdd.vue?vue&type=template&id=89a43040"
import script from "./SampleResultAdd.vue?vue&type=script&lang=js"
export * from "./SampleResultAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports